import React, { Component } from 'react';
import './NotFound.css';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { APP_URL } from '../Constantes';

class NotFound extends Component {
    render() {
        return (
            <div className="page-not-found">
                <h1 className="title">
                    404
                </h1>
                <div className="desc">La page que vous recherchez n'a pas été trouvée.</div>
                <Link to={APP_URL.HOME.value}><Button className="go-back-btn" type="primary" size="large">Accueil</Button></Link>
            </div>
        );
    }
}

export default NotFound;